import React from 'react';
import WelcomeDesktopRender from './WelcomeDesktopRender';
import './css/WelcomeMobileDeviceFit.css';
import MobileViewport from '../appComponents/mobile/MobileViewport';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
/**
 * Same responsive welcome experience on mobile and desktop.
 * A shared component eliminates divergent login/reset behavior between views.
 */
const WelcomeMobileRender = props => <><MobileViewport /><WelcomeDesktopRender {...props} mobileLanguageSwitch /></>;

export default WelcomeMobileRender;
